import React, {useEffect, useRef, useState} from "react";
import PropTypes from 'prop-types';

import {flowManager} from "../managers/FlowManager";
import {dataManager} from "../managers/DataManager";
import {StepHeader} from "../components/StepHeader";
import {StepCategory} from "../components/StepCategory";
import {TileCheckbox} from "../components/TileCheckbox";
import {SubCategoryTile} from "../components/SubCategoryTile";
import {dataKeys} from "../enums/dataKeys";

AccountCategoryStep.propTypes = {
  index: PropTypes.number
}

export function AccountCategoryStep(props) {
  const name = AccountCategoryStep.name;
  const data = dataManager.store(state => state.data); // Data is updated on state change.
  const steps = flowManager.store(state => state.steps); // Steps is updated on state change.
  const stepRef = useRef(null);
  const [checkValue, setCheckValue] = useState("");
  const options = {};

  // On mount, focus the step and scroll into view.
  useEffect(() => {
    stepRef.current.focus({ preventScroll: true });
    window.scrollTo({
      top: (stepRef.current.offsetTop - 120),
      behavior: "smooth"
    });
  }, [])

  useEffect(() => {
    const entry = data.find(item => item.name === name);
    if (entry) {
      setCheckValue(entry.value);
    }
  }, [data, name])

  function handleSelect(event) {
    const value = event.target.value;
    const data = options[value].data;
    const action = data.action;
    const entry = { name, value, ...data };

    flowManager.nextActionStep(props.index, entry, action);
  }

  // General
  options[`general-0`] = {
    title: "Name / E-mail",
    icon: "name",
    data: { ...AccountCategoryStep.nameAndMail }
  };
  options[`general-1`] = {
    title: "Profile Picture",
    icon: "profile-picture",
    data: { ...AccountCategoryStep.profile }
  };
  options[`general-2`] = {
    title: "Delete Account",
    icon: "delete",
    data: { ...AccountCategoryStep.delete }
  };
  options[`general-3`] = {
    title: "Other",
    icon: "other",
    data: { ...AccountCategoryStep.other }
  };

  // Security
  options[`security-0`] = {
    title: "Password",
    icon: "password",
    data: { ...AccountCategoryStep.password }
  };
  options[`security-1`] = {
    title: "2FA",
    icon: "mfa",
    data: { ...AccountCategoryStep.mfa }
  };

  return (
    <>
      <div ref={stepRef} tabIndex={0} className="support-form-step">
        <StepHeader
          index={props.index}
          question="How can we help you with your account?"
          description="Choose the category that describes your question or problem best."
        />
        <div className="support-form-step__categories">
          <StepCategory heading="General">
            {Object.entries(options).map(([value, option]) => {
              return value.startsWith("general") && (
                <TileCheckbox key={value} name={name} value={value} check={checkValue} onChange={handleSelect}>
                  <SubCategoryTile title={option.title} icon={option.icon}/>
                </TileCheckbox>
              )
            })}
          </StepCategory>
          <StepCategory heading="Security">
            {Object.entries(options).map(([value, option]) => {
              return value.startsWith("security") && (
                <TileCheckbox key={value} name={name} value={value} check={checkValue} onChange={handleSelect}>
                  <SubCategoryTile title={option.title} icon={option.icon}/>
                </TileCheckbox>
              )
            })}
          </StepCategory>
        </div>
      </div>
      {steps.length === props.index + 1 && (
        <div className="support-form-step">
          <StepHeader
            index={props.index + 1}
            question="Select one of the above options."
          />
        </div>
      )}
    </>
  );
}


AccountCategoryStep.nameAndMail = {
  action: "nameAndMail",
  [dataKeys.labels]: ["name", "email"],
  [dataKeys.path]: ["Name / E-mail"]
}
AccountCategoryStep.profile = {
  action: "profile",
  [dataKeys.labels]: ["profile-picture"],
  [dataKeys.path]: ["Profile Picture"]
}
AccountCategoryStep.delete = {
  action: "delete",
  [dataKeys.labels]: ["delete"],
  [dataKeys.path]: ["Delete Account"]
}
AccountCategoryStep.other = {
  action: "other",
  [dataKeys.labels]: ["other"],
  [dataKeys.path]: ["Other"]
}
AccountCategoryStep.password = {
  action: "password",
  [dataKeys.labels]: ["password"],
  [dataKeys.path]: ["Password"]
}
AccountCategoryStep.mfa = {
  action: "mfa",
  [dataKeys.labels]: ["2fa"],
  [dataKeys.path]: ["2FA"]
}


